var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11111 11C1.80556 11 1.54398 10.8912 1.32639 10.6736C1.1088 10.456 1 10.1944 1 9.88889V2.11111C1 1.80556 1.1088 1.54398 1.32639 1.32639C1.54398 1.1088 1.80556 1 2.11111 1H9.88889C10.1944 1 10.456 1.1088 10.6736 1.32639C10.8912 1.54398 11 1.80556 11 2.11111V9.88889C11 10.1944 10.8912 10.456 10.6736 10.6736C10.456 10.8912 10.1944 11 9.88889 11H2.11111ZM2.11111 9.88889H9.88889V2.11111H2.11111V9.88889Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxS);
export default __webpack_public_path__ + "static/media/check-box-s.b4fe9321ba88f69d37e3bc73e9ddfb60.svg";
export { ForwardRef as ReactComponent };